import { ENV } from '../config/config'
const { cdnBaseUrl } = ENV
const favIcon = `${cdnBaseUrl}v1655727474/hex-nft/assets/mynist_s1vmud.png`;

export const Images = {
    favIcon
}